import type React from "react";

import FlexedBiceps from "@/assets/images/flexed-biceps.png";
import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { useTranslation } from "@/translations";

type SessionFinishedModalProps = ModalBaseProps & {
  data?: {
    missedItems: number;
  };
};

export function SessionFinishedModal({ isOpened, onOpenChange, data }: SessionFinishedModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("page.portfolio.tickets.session-finished.title")}
      size="sm"
      description={
        data && data.missedItems > 0
          ? t("page.portfolio.tickets.session-finished.missed", { count: data.missedItems })
          : t("page.portfolio.tickets.session-finished.no-missed")
      }
      {...{ isOpened, onOpenChange }}
    >
      <Modal.Body centered>
        <img src={FlexedBiceps} alt="" width={80} height={80} />
      </Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button>{t("common.action.close")}</Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
